var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11 13.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1.834 11.807v-1.614c0-.953.779-1.741 1.741-1.741 1.66 0 2.338-1.174 1.503-2.613a1.74 1.74 0 0 1 .642-2.374l1.586-.908c.724-.43 1.66-.174 2.09.55l.1.175c.826 1.439 2.182 1.439 3.017 0l.1-.175c.431-.724 1.366-.98 2.09-.55l1.586.908a1.74 1.74 0 0 1 .642 2.374c-.834 1.44-.156 2.613 1.503 2.613.954 0 1.742.779 1.742 1.741v1.614c0 .953-.78 1.741-1.742 1.741-1.659 0-2.337 1.174-1.503 2.613a1.74 1.74 0 0 1-.642 2.374l-1.586.907c-.724.431-1.659.175-2.09-.55l-.1-.174c-.825-1.439-2.182-1.439-3.016 0l-.101.174c-.43.725-1.366.981-2.09.55l-1.586-.907a1.74 1.74 0 0 1-.641-2.374c.834-1.44.155-2.613-1.504-2.613a1.747 1.747 0 0 1-1.742-1.741"
  })));
};
export default SvgSettings;